import React from "react";

export default class WBPopup extends React.Component {
  render() {
    return (
      <div
        id="divDialog"
        class="dialog boxshadow"
        style={{ overflowY: "auto" }}
      >
        <div class="dialog_content" style={{ overflowY: "auto" }}>
          <p align="justify">
            National Remote Sensing Centre (NRSC) is one of the implementing
            agencies under National Hydrology Project (NHP). Under NHP, NRSC is
            establishing evaporative flux monitoring system for entire India.
            Under this project, it is proposed to estimate evaporative flux with
            space-based input along with meteorological data. Towards
            development of evaporative flux monitoring system for Indian region
            NRSC has developed procedure for daily evaporative flux estimation
            based on satellite remote sensing data at an appropriate spatial
            scale.
          </p>{" "}
          <p align="justify">
            Evapotranspiration (ET) is the process by which the water gets
            transported from soil and/or the vegetation to the atmosphere. In
            this process the energy also gets transported from land to
            atmosphere. The main drivers for this process are i) solar
            radiation, ii) vapour pressure gradient between the evaporating
            surface and the atmosphere and iii) the resistance that the land
            cover offers to the process. ET can be determined by direct
            measurement or estimated through hydro meteorological parameters.
            Beside direct methods, there were many empirical and analytical
            methods are developed to calculate ET from the meteorological data
            and energy fluxes.
          </p>{" "}
          <p align="justify">
            Analytical methods estimate ET based on the meteorological
            parameters and energy fluxes. Using these methods, ET can be
            determined by energy balance or mass (water) balance approach. Under
            this project these two approaches are implemented and products are
            being disseminated through NHP portal.{" "}
          </p>
          <br />
          <strong>Soil Water Balance Approach</strong>{" "}
          <p align="justify">
            Since modified Priestley Taylor based algorithm relies primarily on
            datasets from optical satellite sensors, estimation of actual ET
            using this approach are not consistent in Kharif season due to
            persistent cloud cover during Monsoon. Therefore, a soil water
            balance model is developed which computes evapotranspiration by
            assessing water stress conditions limiting soil evaporation and
            transpiration from vegetated areas. This soil water balance approach
            is based on dual crop coefficient approach as described in FAO-56
            (Allan, 1998).This approach defines adjusted evapotranspiration as:
          </p>
          ET<sub>adj</sub>=(K<sub>S</sub>K<sub>cb</sub>+K<sub>e</sub>)ET
          <sub>0</sub>---- (1)
          <p align="justify">
            Where, ET<sub>adj</sub> is known as adjusted evapotranspiration, K
            <sub>s</sub>
            is known as water stress coefficient, K<sub>cb</sub> is described as
            basal crop coefficient, K<sub>e</sub> is known as soil evaporation
            coefficient. ET<sub>0</sub> is reference evapotranspiration. This
            model derives K<sub>cb</sub> using Leaf Area Index and Vegetation
            Fraction using following relation.{" "}
          </p>
          K<sub>cb</sub> = K<sub>cb,min</sub> +K<sub>d</sub>(K<sub>cb,full</sub>
          -K<sub>cb,min</sub>) --- (2)
          <p align="justify">
            K<sub>cb,min</sub> is crop coefficient for bare soil and assumed be
            0.15 in the model. The density coefficient (K<sub>d</sub>) is
            related to crop cover on the ground and hence can be modeled in
            terms of Leaf Area Index (Pocas, Paco, Perades, Cunha, &amp;
            Pereira, 2015). The model uses following relationship between Kd and
            LAI as given by Allen et al., 1998.
          </p>
          K<sub>d</sub> = (1-e<sup>-0.7LAI</sup>) --- (3)
          <p align="justify">
            The term in multiplication of K<sub>d</sub> in definition of K
            <sub>cb</sub> can be approximated by the vegetation fraction.
            Vegetation fraction is defined as the vertical occupation of
            vegetation canopy on the ground. Vegetation fraction is defined as
            following.
          </p>
          Vegetation Fraction= VI-VI<sub>minimumu</sub> / VI<sub>maximum</sub>{" "}
          -VI<sub>minimumu</sub> --- (4)
          <p align="justify">
            The water stress coefficient (Ks) and soil evaporation coefficient
            (Ke) are derived using soil data from Harmonized World Soil Database
            (HWSD) and soil moisture products from SMAP and SMOS missions. The
            soil water characteristics are obtained using texture and organic
            matter content information which provided with HWSD database (Saxton
            &amp; Rawls, 2006).{" "}
          </p>
          The input datasets being utilized in soil water balance model are
          listed in Table below.
          <p align="justify">
            The soil water balance model is run at daily for different passes of
            SMOS over India. The computations of evapotranspiration for
            different passes are averaged on a given day to generate a single
            day mosaic. SMOS which has a swath of 900 Km can’t provide surface
            soil moisture for entire Indian region on a given day; therefore, a
            3-day average product of evapotranspiration at 15 km spatial
            resolution is finally generated and disseminated with 3-day latency.
            As part of this activity, under NHP it is also planned to validate
            this satellite based estimates across the country. Towards this, it
            is planned to establish AET measurement instrumentation across the
            country under diverse agro-climatic zone. Although limited
            validation of estimated product is carried out with global satellite
            based AET products and ground observations.
          </p>
          <strong>Reference</strong>
          <ol>
            <li>
              Allan, R. &amp;. (1998). Crop evapotranspiration-Guidelines for
              computing crop water requirements. FAO Irrigation and drainage
              paper 56 .
            </li>
            <li>
              Pocas, I., Paco, T. A., Perades, P., Cunha, M., &amp; Pereira, L.
              S. (2015). Estimation of Actual Crop Coefficients Using Remotely
              Sensed Vegetation Indices and Soil Water Balance Modelled Data.
              Remote Sensing .
            </li>
            <li>
              Saxton, K. E., &amp; Rawls, W. J. (2006). Soil Water
              Characteristic Estimates by Texture and Organic Matter for
              Hydrologic Solutions. Soil Science Society of America Journal , 70
              (5).
            </li>
          </ol>
        </div>
        {/* 
<div class="dialog-statusbar">Ready</div> */}
      </div>
    );
  }
}
